import L from "leaflet";
import React from "react";
import { Marker, Popup } from "react-leaflet";
import { Ride } from "../../../types/Warps";
import star from "../../../assets/star.png";
import { sendWarpEvent } from "../../../helper/WebsocketClient";
import { coreDataStore } from "../../../helper/CoreDataStorage";

interface Props {
  ride_data: Ride;
  x: number;
  y: number;
}

const RideMarker: React.FC<Props> = ({ ride_data, y, x }) => {
  const icon = L.divIcon({
    html: `
     <div class="w-full h-full flex items-center justify-center pointer-events-none">
    <div class="p-2 bg-violet-400 border-2 border-violet-200 rounded-full pointer-events-none">
      <img src="${star}" class="w-5 h-5  pointer-events-none" />
    </div>
  </div>
  `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    className: "",
  });

  return (
    <Marker position={[y, x]} icon={icon}>
      <Popup>
        <div className="w-[200px] h-auto bg-gray-900 text-white rounded-lg overflow-hidden">
          {ride_data.image && (
            <img
              src={ride_data.image}
              className="w-full h-24 object-cover"
              alt=""
            />
          )}

          <div className="p-2 flex flex-col items-start justify-between select-none">
            <h1 className="text-xl">{ride_data.name}</h1>
            <p className="bg-red-600 rounded-full px-2 py-1 text-xs">Ride</p>
            <h2 className="text-base">{ride_data.description}</h2>
            <button
              className="mt-3 w-full bg-transparent hover:opacity-80 border-2 text-white py-2 rounded-xl"
              onClick={() => {
                if (
                  coreDataStore.ws &&
                  coreDataStore.session_token &&
                  coreDataStore.ws.OPEN
                ) {
                  sendWarpEvent(
                    coreDataStore.ws,
                    coreDataStore.session_token,
                    ride_data,
                  );
                }
              }}
            >
              Click to warp
            </button>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default RideMarker;
